import t from "./shared/offsetMonth.js";
const f = t(0);
export {
  f as default
};
